<template>
  <v-app v-if="loading">
    <v-main>
      <div v-if="domaintrue" style="
          background-color: #005672;
          color: white;
          padding: 10px 50px;
          font-size: 16px;
          display: flex;
          justify-content: space-between;
        ">
        <div>
          <span>{{ $t("geoipContent.text1") }} {{ countryname }}
            {{ $t("geoipContent.text2") }}
          </span>
          <span class="text-capitalize ms-1">{{ searchDomaintitle }}</span>.
          <span>{{ $t("geoipContent.text3") }} {{ visitcountryname }}
            {{ $t("geoipContent.text4") }}</span>
          <span @click="routerDomain" class="border-bottom border-1 fw-500 ms-1" style="cursor: pointer">
            {{ dataDomain }}
          </span>
        </div>
        <div>
          <v-icon color="red" @click="domaintrue = false">
            mdi-close-circle-outline
          </v-icon>
        </div>
      </div>
      <div v-if="datashow">
        <div id="navbar">
          <component :is="selectedHeader" />
        </div>
        <div class="bg-pages">
          <router-view />
        </div>

        <div id="food">
          <component :is="selectedFooter" />
        </div>
      </div>
    </v-main>
  </v-app>

  <div v-if="dataLoader">
    <dataloader></dataloader>
  </div>

  <div v-if="dotLoader">
    <dotLoader></dotLoader>
  </div>
</template>

<script>
import axios from "axios";
import dataloader from "@/components/dataLoder.vue";
import dotLoader from "@/components/dotLoader.vue";
import headerCom1 from "@/components/headerCom1.vue";
import aboutUs from "@/components/aboutUs.vue";
import country1 from "@/coundtrycode.json";
import CryptoJS from "crypto-js";

import headerCom from "@/components/headerCom.vue";
import headerCom2 from "@/components/headerCom2.vue";
import headerCom3 from "@/components/headerCom3.vue";

import footerCom from "@/components/footerCom.vue";
import footerCom1 from "@/components/footerCom1.vue";
import footerCom2 from "@/components/footerCom2.vue";
import footerCom3 from "@/components/footerCom3.vue";

// import { checkAndRedirect } from "@/utils/redirection.js";

import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";

export default {
  name: "App",
  components: {
    headerCom1,
    aboutUs,
    dataloader,
    dotLoader,
    headerCom,
    headerCom2,
    headerCom3,
    domaintrue: false,
    footerCom,
    footerCom1,
    footerCom2,
    footerCom3,
  },
  data: () => ({
    headerStyles: ["headerCom", "headerCom1", "headerCom2", "headerCom3"],
    footerStyles: ["footerCom", "footerCom1", "footerCom2", "footerCom3"],
    navbar: true,
    food: true,
    datashow: false,
    countryname: "",
    selectedHeader: "headerCom1",
    selectedFooter: "footerCom",
    loading: false,

    dataLoader: false,
    dotLoader: true,

    dataDomain: "",
    dataDomainData: "",
    SearchDomain: "",
    searchDomaintitle: "",
    countryOptions: [],
    visitcountryname: "",
    getLanguages: "",
    countyIsocode: "",
    siteContentData: "",
    languageData: "",

    configReq: {
      service_type: "GetPortalConfigRQ",
      api_ver: "1",
      payload: {
        domain_name: "buymytrip.ca",
        env: "CERT",
        language: "EN",
        token: "jsdjOJDKJ7675",
      },
    },
    configUser_Id: "",
    tawktoApi: "",
  }),

  methods: {
    indexHeader() {
      const getConfigData = getConfigDataFromLocalStorage();

      if (getConfigData) {
        let portalTitle = getConfigData.payload.portal_configuration.site_title;
        let portalFavicon = getConfigData.payload.portal_configuration.favicon;

        let pluginTawkto = "";
        pluginTawkto =
          getConfigData.payload.portal_configuration.menus.enabled.plugins;
        // console.log(pluginWhats, 'dasdasdasda..1..1..1.1')
        if (pluginTawkto.includes("tawkto")) {
          this.tawktoApi =
            getConfigData.payload.portal_configuration.API_endpoints.tawkto;
          // console.log(this.tawktoApi, " this.tawktoApithis.tawktoApi ");
        } else {
          this.tawktoApi = "";
        }

        document.getElementById("siteTitle").innerText = portalTitle;
        document.getElementById("faviconPortal").href = portalFavicon;

        // Tawk.to code
        const s1 = document.createElement("script");
        const s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = this.tawktoApi;
        s1.charset = "UTF-8";
        s1.setAttribute("crossorigin", "*");
        s0.parentNode.insertBefore(s1, s0);
      }
    },

    async envPortal() {
      let hostname = window.location.hostname;
      console.log(hostname, "hshshshs....")
      if (hostname == "localhost") {
        console.log(hostname, "localhost....");
      } else {
        this.configReq.payload.domain_name = hostname;
        console.log(this.configReq.payload.domain_name, "localhost....1");
      }

      console.log(this.configReq, "configReqqqqq");
      // await axios.get("https://dltest.wistirna.com/api/getportalconfig", {
      await axios.get("https://dl.buymytrip.com/api/getportalconfig", {
          params: this.configReq,
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          if (response) {
            console.log(response.data, "DelayDelayDelayDelayDelay");
            this.dotLoader = false;
            this.loading = true;
            let configResponse = response.data;

            // Encrypt data using CryptoJS
            const secretKey = "portal_config_datas";
            const encryptedData = CryptoJS.AES.encrypt(
              JSON.stringify(configResponse),
              secretKey
            ).toString();

            localStorage.setItem("portalData", encryptedData);

            this.dataDomainData =
              configResponse.payload.portal_configuration.geoip_location.country_domain.replace(
                "https://",
                ""
              );

            this.dataDomain =
              this.dataDomainData.charAt(0).toUpperCase() +
              this.dataDomainData.slice(1);
            this.SearchDomain = this.configReq.payload.domain_name;
            this.searchDomaintitle = configResponse.payload.portal_configuration.site_title;
            this.countryname = configResponse.payload.portal_configuration.country.name;


            this.getLanguages = configResponse.payload.portal_configuration.languages;

            this.countyIsocode = configResponse.payload.portal_configuration.country.iso_code;

            if (this.getLanguages && this.countyIsocode) {
              this.setLanguage();
              console.log('working...1')
              // this.$i18n.locale = `${this.countyIsocode}-${this.getLanguages[0].code}`
              // console.log(this.$i18n.locale, "langresponseresponse...1");
            }
            else{
              this.$i18n.locale = 'CA-en';
              console.log('working...2')
              // this.$i18n.locale = `${this.countyIsocode}-${this.getLanguages[0].code}`
            }


            let $dataname =
              configResponse.payload.portal_configuration.geoip_location
                .country_iso_code;
            let portalurl =
              configResponse.payload.portal_configuration.geoip_location
                .portal_url;
            // console.log(this.dataDomain,this.SearchDomain, 'response.data')

            this.countryOptions = configResponse.payload.portal_configuration.country_options;

            this.siteContentData = configResponse.payload.portal_configuration.site_content_data;


            this.languageData = configResponse.payload.portal_configuration.language_data;

            if (this.languageData) {
              this.getlangaugeUrl();
              // this.localeLanguage();
            }

            console.log(this.languageData, 'siteContentDatasiteContentDatasiteContentData')

            // let siteContent = []
            // siteContent.push(this.siteContentDatsdfsdfsfdsa)

            // console.log(siteContent[0],'siteContentsiteContentsiteContent');



            console.log(this.countryOptions, "thiscountryOptions");


            let hrefData = "";
            console.log(this.$route.query, "this.$route.query.id;");
            if (this.$route.query.refer == "web") {
              console.log(this.$route.query.id, "this.$route.query.id;");
            } else if (this.$route.query.ref == "web") {
              console.log(this.$route.query.ref, "this.$route.query.id;");
            }

            // else if (window.location.pathname !==portalurl) {
            //   console.log(window.location.pathname, "window.location.pathname");
            // }
            else if (window.location.href == portalurl) {
              this.countryOptions.forEach((c) => {
                if (c.default_domain) {
                  hrefData = c.portal_url;
                  // hrefData = "http://localhost:8080";
                }

                if (c.country_code !== $dataname && c.default_domain) {
                  this.domaintrue = false;
                  if (c.portal_url !== portalurl) {
                    // window.location.href =hrefData;
                    window.location.href = `${hrefData}?ref=web&redirect=false`;
                    console.log(c, "country");
                  }
                }

                if (c.country_code == $dataname) {
                  if (c.portal_url !== portalurl) {
                    // this.domaintrue = true;
                    window.location.href = `${hrefData}?refer=web&redirect=false`;
                  }
                }
              });

              country1.forEach((v) => {
                if ($dataname == "US" || $dataname == "CA") {
                  if (v.code == $dataname) {
                    this.visitcountryname = v.name;
                  }
                } else {
                  this.visitcountryname = "Global";
                }
              });
            } else {
              console.log("pp");
            }

            // let routerPath = location.href;
            // console.log(this.dataDomainData, this.SearchDomain, "popopopop");
            // if (
            //   this.dataDomainData.includes(this.SearchDomain) ||
            //   routerPath.includes("env=cert")
            // ) {
            //   console.log("pppppppaduhdh");
            //   this.domaintrue = false;
            // } else {
            //   this.domaintrue = true;
            // }

            // localStorage.setItem("portalData", JSON.stringify(configResponse))

            if (configResponse) {
              this.datashow = true;
            }
            this.indexHeader();
          }
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
          // alert('Something went difficulties...')
          setTimeout(() => {
            this.envPortal();
          }, 5000);

          this.loading = false;
        });
    },

    setLanguage() {
      let getLang = this.getLanguages[0].code;
      let savedLanguage = `${this.countyIsocode}-${getLang}`;
      localStorage.setItem("setlang", savedLanguage);
      // let setlocalLang = localStorage.setItem("setlang", savedLanguage);
      // if(setlocalLang){
      //   this.localeLanguage();
      // }
    },

    // getRandomChars(length) {
    //   let result = "";
    //   for (let i = 0; i < length; i++) {
    //     const randomIndex = Math.floor(Math.random() * this.strResult.length);
    //     result += this.strResult[randomIndex];
    //   }
    //   console.log(result, "result");
    //   return result;
    // },
    // getRandomInt(min, max) {
    //   return Math.floor(Math.random() * (max - min + 1)) + min;
    // },

    // generatePortalConfig_id() {
    //   const randomChars1 = this.getRandomChars(3);
    //   const randomNum = this.getRandomInt(10, 99);
    //   const randomChars2 = this.getRandomChars(3);

    //   this.configUser_Id = randomChars1 + randomNum + randomChars2;
    //   console.log(this.configUser_Id, 'configUser_IdconfigUser_Id')
    // },

    // async envPortal() {
    //   try {
    //     const response = await axios.get("https://dl.buymytrip.com/api/getportalconfig", {
    //       params: this.configReq,
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     });

    //     if (response) {
    //       let configResponse = response.data;
    //       console.log(configResponse, 'sdfdhfiadfadh');
    //       localStorage.setItem('portalData', JSON.stringify(configResponse));
    //       this.indexHeader();
    //     }
    //   } catch (error) {
    //     console.log("Error fetching data:", error);
    //     alert('Something went wrong...');
    //   }
    // },

    localeLanguage() {
      const storedLocale = localStorage.getItem("defaultlang");
      const storedSetLang = localStorage.getItem("setlang");

      let getlocalIso = "";
      let getlocalLang = "";
      let getsetIso = "";
      let getsetlang = "";
      // let savedLanguage = "";


      if (storedLocale) {
        getlocalIso = storedLocale.split('-')[0];
        getlocalLang = storedLocale.split('-')[1];
      }
      if (storedSetLang) {
        getsetIso = storedSetLang.split('-')[0];
        getsetlang = storedSetLang.split('-')[1];
      }


      if (storedSetLang && storedLocale) {
        console.log('Check...1');
        if (storedLocale == storedSetLang) {
          console.log('Check...2');

          return storedSetLang;
          // this.i18n.locale = storedSetLang;
        }
        else if (storedLocale !== storedSetLang) {
          console.log(getlocalIso, getsetIso, 'Check...3', getlocalLang, getsetlang);
          if (getlocalIso !== getsetIso && getlocalLang !== getsetlang) {

            localStorage.removeItem("defaultlang");
            console.log('Check...4');
            return storedSetLang;
            // this.i18n.locale = storedSetLang;

          }
          else if (getlocalIso == getsetIso && getlocalLang !== getsetlang) {
            console.log(storedLocale, 'Check...5');

            return storedLocale;
            // this.i18n.locale = storedLocale;
          }
        }
      }
      else if (storedSetLang) {
        console.log('Check...6');

        return storedSetLang;
        // this.i18n.locale = storedSetLang;
      }
      else if (storedLocale) {
        console.log('Check...7');

        return storedLocale;
        // this.i18n.locale = storedLocale;
      }
      else {
        console.log('Check...8');

        return 'CA-en';
        // return `${this.countyIsocode}-${this.getLanguages[0].code}`;

        // this.i18n.locale = `${this.countyIsocode}-${this.getLanguages[0].code}`;
      }
    },


    getlangaugeUrl() {

      let langData = this.languageData
      // console.log(langData, 'languageDatalanguageDatalanguageData...1');
      // let getlocale = this.localeLanguage();
      // this.$i18n.locale = this.localeLanguage();
      var localLang = this.localeLanguage(); //CA.es

      // console.log(localLang, 'languageDatalanguageDatalanguageData...2');

      let langdataUrl = "";
      // console.log(localLang,'localLanglocalLang')
      Object.keys(langData).forEach(v => {
        // console.log(v,this.countyIsocode, 'languageDatalanguageDatalanguageData...3');
        if (v == this.countyIsocode) {
          const lang = langData[v];

          Object.keys(lang).forEach(local => {
            // console.log(local, 'dasasasasdas')
            if (local == localLang) {

              langdataUrl = lang[local]
              console.log(local, localLang, langdataUrl, 'dasasasasdas...2');

              // if(langdataUrl == "https://dl.buymytrip.com/api/getLang?domain=buymytrip.ca&language=CA-fr"){
              //   this.$i18n.locale = 'CA-fr';
              //   console.log(langdataUrl,'urlurlurlurlurlurlurl....1')
              // }
              // else{
              //   console.log(langdataUrl,'urlurlurlurlurlurlurl....2')
              //   return langdataUrl
              // }

              axios.get(langdataUrl, {
                headers: {
                  "Content-Type": "text/html; charset=utf-8",
                },
              })
                .then((response) => {
                  if (response) {
                    // this.aboutContent = response.data
                    // console.log(response, "langresponseresponse...2");
                    // console.log(response.data, "langresponseresponse");
                    const cleanedData = this.parseLanguageData(response.data);
                    this.setLanguageMessages(localLang, cleanedData);
                    // setInterval(() => {
                    //   location.reload();
                    // }, 500);
                    // this.dataloader = false;
                  }
                  // else {
                  //   this.$i18n.locale = `${this.countyIsocode}-${this.getLanguages[0].code}`
                  //   console.log(this.$i18n.locale, "langresponseresponse...1");
                  // }
                })
                .catch((error) => {
                  console.log(error, 'errorrLangaugeAPI.....')

                  this.$i18n.locale = 'CA-en'
                  // this.dataloader = true;
                })
            }
          })
        }
      });
    },


    parseLanguageData(data) {
      try {
        const cleanedData = data
          .replace(/export\s+default\s+/, '')
          .replace(/;\s*$/, ''); // Remove trailing semicolon if present
        return eval(`(${cleanedData})`);
      } catch (error) {
        console.error('Error processing language content:', error);
        return {};
      }
    },

    setLanguageMessages(locale, messages) {
      this.$i18n.setLocaleMessage(locale, messages);
      this.$i18n.locale = locale;

      console.log(this.$i18n.locale,'setLanguageMessagessetLanguageMessages')
    }
  },

  // mounted() {
  //   checkAndRedirect();
  //   console.log(checkAndRedirect(),'checkAndRedirectcheckAndRedirectcheckAndRedirect')
  // },

  // mounted() {
  //   window.__be = window.__be || {};
  //   window.__be.id = "65fc2b19daf9d00006243bf9";
  //   (function () {
  //     var be = document.createElement("script");
  //     be.type = "text/javascript";
  //     be.async = true;
  //     be.src =
  //       ("https:" == document.location.protocol ? "https://" : "http://") +
  //       "cdn.chatbot.com/widget/plugin.js";
  //     var s = document.getElementsByTagName("script")[0];
  //     s.parentNode.insertBefore(be, s);
  //   })();
  // },


  watch: {
    "$i18n.locale": {
      immediate: true,
      handler: function () {
        // this.localeLanguage();
        this.getlangaugeUrl();
      },
      // deep: true,
    },

    "$route.path": {
      immediate: true,
      handler(newValue) {
        if (newValue === "/loader") {
          this.navbar = false;
          this.food = false;
        } else {
          this.navbar = true;
          this.food = true;
        }
        // console.log(newValue, '4545');
      },
    },

    // '$i18n.locale': function () {
    //   this.getlangaugeUrl();
    // }
  },



  created() {
    this.envPortal();
    getConfigDataFromLocalStorage(this);
    console.log(window.location.href, "window.location.pathname");
    console.log(window.location.hostname, "window.location.hostname");
    // this.localeLanguage();
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300&family=Poppins:wght@300;400;500&display=swap");

/* .bg-pages {
background: rgb(230, 217, 26);
background: linear-gradient(to right, rgb(45 129 253 / 65%), rgb(193 193 193));
} */

* {
  font-family: "Poppins", sans-serif;
}

#navbar {
  display: block;
}

#food {
  display: block;
}

.f-size-20 {
  font-size: 20px;
}

.f-size-16 {
  font-size: 16px;
}

.f-size-15 {
  font-size: 15px;
}

.f-size-14 {
  font-size: 14px;
}

.f-size-13 {
  font-size: 13px;
}

.f-size-12 {
  font-size: 12px;
}

.f-size-11 {
  font-size: 11px;
}

.f-size-10 {
  font-size: 10px;
}

.f-size-9 {
  font-size: 9px;
}

.fw-400 {
  font-weight: 400;
}

.fw-500 {
  font-weight: 500;
}

.fw-600 {
  font-weight: 600;
}

/* .tawk-branding{
  display:none !important;
} */

/* .bg-pages{
    background-image:url('./assets/bmbg2.svg');
  } */

/* .bg-pages{
    background: linear-gradient(90deg, rgba(148, 187, 233, 0.7512254901960784) 0%, rgba(238, 174, 202, 1) 50%, rgba(148, 187, 233, 0.7456232492997199) 100%);
  } */
/* .bg-pages { */

/* background-image: url(https://andit.co/projects/html/and-tour/demo/assets/img/banner/bg.png); */
/* background: rgb(230, 217, 26); */
/* background: linear-gradient(277deg, rgba(230,217,26,1) 0%, rgba(51,175,167,1) 58%, rgba(253,45,164,1) 100%); */
/* background: linear-gradient(to right, rgb(45 129 253 / 65%), rgb(193 193 193)); */

/* margin-top:70px; */
/* background-image: url(https://andit.co/projects/html/and-tour/demo/assets/img/banner/bg.png); */
/* } */
</style>
